
 
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const GetActivationChannels = /* GraphQL */ `query GetActivationChannels($engagementId: String!) {
  GetActivationChannels(engagementId: $engagementId) {
    awsRegion
    bucketName
    channelId
    channelType
    connectionStatus
    createdAt
    createdBy
    description
    engagement
    iamRoleArn
    lastModifiedAt
    lastModifiedBy
    name
    orgType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActivationChannelsQueryVariables,
  APITypes.GetActivationChannelsQuery
>;
export const GetAggregateResult = /* GraphQL */ `query GetAggregateResult($resultRequest: AggregateResultRequest) {
  GetAggregateResult(resultRequest: $resultRequest) {
    headers
    rows
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAggregateResultQueryVariables,
  APITypes.GetAggregateResultQuery
>;
export const GetChart = /* GraphQL */ `query GetChart($chartId: String!, $engagementId: String!) {
  GetChart(chartId: $chartId, engagementId: $engagementId) {
    athenaExecutionId
    chartId
    chartType
    chartsImageUrl
    config
    createdAt
    createdBy
    dashboardIds
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    name
    orgType
    queryId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetChartQueryVariables, APITypes.GetChartQuery>;
export const GetCharts = /* GraphQL */ `query GetCharts($engagementId: String!) {
  GetCharts(engagementId: $engagementId) {
    athenaExecutionId
    chartId
    chartType
    chartsImageUrl
    config
    createdAt
    createdBy
    dashboardIds
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    name
    orgType
    queryId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetChartsQueryVariables, APITypes.GetChartsQuery>;
export const GetCollaboration = /* GraphQL */ `query GetCollaboration($collaborationRequest: CollaborationDetailsRequest!) {
  GetCollaboration(collaborationRequest: $collaborationRequest) {
    data {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCollaborationQueryVariables,
  APITypes.GetCollaborationQuery
>;
export const GetCollaborationList = /* GraphQL */ `query GetCollaborationList($collaborationRequest: CollaborationListRequest!) {
  GetCollaborationList(collaborationRequest: $collaborationRequest) {
    collaborationList {
      collaborationId
      createdAt
      createdBy
      description
      lastModifiedAt
      lastModifiedBy
      name
      objective
      orgType
      ownerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerDatasets {
        dataConnectionId
        dataConnectionName
        schemaName
        tableName
        __typename
      }
      partnerEmail
      partnerInviteMessage
      partnerOrgType
      status
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCollaborationListQueryVariables,
  APITypes.GetCollaborationListQuery
>;
export const GetDashboard = /* GraphQL */ `query GetDashboard($dashboardId: String!, $engagementId: String!) {
  GetDashboard(dashboardId: $dashboardId, engagementId: $engagementId) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    layout
    name
    orgType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardQueryVariables,
  APITypes.GetDashboardQuery
>;
export const GetDashboardNames = /* GraphQL */ `query GetDashboardNames($dashboardIds: [String!]!, $engagementId: String!) {
  GetDashboardNames(dashboardIds: $dashboardIds, engagementId: $engagementId) {
    dashboardId
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardNamesQueryVariables,
  APITypes.GetDashboardNamesQuery
>;
export const GetDashboards = /* GraphQL */ `query GetDashboards($engagementId: String!) {
  GetDashboards(engagementId: $engagementId) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    engagement
    lastModifiedAt
    lastModifiedBy
    layout
    name
    orgType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardsQueryVariables,
  APITypes.GetDashboardsQuery
>;
export const GetDataConnection = /* GraphQL */ `query GetDataConnection($connectionId: String!, $orgType: String!) {
  GetDataConnection(connectionId: $connectionId, orgType: $orgType) {
    accessKeyId
    awsRegion
    bigQueryEndpoint
    bucketName
    catalogName
    connectionId
    connectionName
    connectionStatus
    connectionType
    createdAt
    createdBy
    databaseName
    description
    engagement
    gcsJsonCredentials
    hostName
    jsonCredentials
    lastModifiedAt
    lastModifiedBy
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_description
      table_name
      __typename
    }
    orgType
    password
    pem_private_key
    portNumber
    projectId
    region
    roleArn
    roleName
    schemaName
    secretAccessKey
    sfUser
    sourceAccountId
    targetAccountId
    username
    warehouseName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataConnectionQueryVariables,
  APITypes.GetDataConnectionQuery
>;
export const GetDataConnectionList = /* GraphQL */ `query GetDataConnectionList($orgType: String!) {
  GetDataConnectionList(orgType: $orgType) {
    dataConnectionList {
      accessKeyId
      awsRegion
      bigQueryEndpoint
      bucketName
      catalogName
      connectionId
      connectionName
      connectionStatus
      connectionType
      createdAt
      createdBy
      databaseName
      description
      engagement
      gcsJsonCredentials
      hostName
      jsonCredentials
      lastModifiedAt
      lastModifiedBy
      metadata {
        columns {
          comment
          description
          identifier
          name
          parameters
          type
          __typename
        }
        dataConnectionId
        database_name
        datasource_name
        row_count
        sync_status
        table_description
        table_name
        __typename
      }
      orgType
      password
      pem_private_key
      portNumber
      projectId
      region
      roleArn
      roleName
      schemaName
      secretAccessKey
      sfUser
      sourceAccountId
      targetAccountId
      username
      warehouseName
      __typename
    }
    metadataList
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataConnectionListQueryVariables,
  APITypes.GetDataConnectionListQuery
>;
export const GetEngagements = /* GraphQL */ `query GetEngagements($organizationType: String!) {
  GetEngagements(organizationType: $organizationType) {
    engagement
    metadata {
      columns {
        comment
        description
        identifier
        name
        parameters
        type
        __typename
      }
      dataConnectionId
      database_name
      datasource_name
      row_count
      sync_status
      table_name
      __typename
    }
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEngagementsQueryVariables,
  APITypes.GetEngagementsQuery
>;
export const GetEntitlements = /* GraphQL */ `query GetEntitlements($role: String!) {
  GetEntitlements(role: $role) {
    entitlements
    role
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntitlementsQueryVariables,
  APITypes.GetEntitlementsQuery
>;
export const GetExportAudiences = /* GraphQL */ `query GetExportAudiences($engagementId: String!) {
  GetExportAudiences(engagementId: $engagementId) {
    approvalStatus
    approvedBy
    attributesMapping
    audienceFrom
    channelId
    engagement
    expireAt
    exportId
    exportStatus
    exportedAt
    exportedBy
    fileType
    folderPath
    orgType
    queryId
    queryName
    rejectReason
    targetChannel
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExportAudiencesQueryVariables,
  APITypes.GetExportAudiencesQuery
>;
export const GetHealth = /* GraphQL */ `query GetHealth {
  GetHealth {
    status
    __typename
  }
}
` as GeneratedQuery<APITypes.GetHealthQueryVariables, APITypes.GetHealthQuery>;
export const GetModel = /* GraphQL */ `query GetModel($engagementId: String!, $modelId: String!) {
  GetModel(engagementId: $engagementId, modelId: $modelId) {
    athenaExecutionId
    createdAt
    createdBy
    engagement
    images
    lastModifiedAt
    lastModifiedBy
    lookalikeNumber
    maxLookalikeNumber
    metadata
    modelId
    modelType
    name
    orgType
    parentId
    queryId
    queryName
    seedAudienceSize
    status
    __typename
  }
}
` as GeneratedQuery<APITypes.GetModelQueryVariables, APITypes.GetModelQuery>;
export const GetModels = /* GraphQL */ `query GetModels($engagementId: String!) {
  GetModels(engagementId: $engagementId) {
    athenaExecutionId
    createdAt
    createdBy
    engagement
    images
    lastModifiedAt
    lastModifiedBy
    lookalikeNumber
    maxLookalikeNumber
    metadata
    modelId
    modelType
    name
    orgType
    parentId
    queryId
    queryName
    seedAudienceSize
    status
    __typename
  }
}
` as GeneratedQuery<APITypes.GetModelsQueryVariables, APITypes.GetModelsQuery>;
export const GetOrganizations = /* GraphQL */ `query GetOrganizations {
  GetOrganizations {
    isDatabricksConnectionAllowed
    orgName
    orgType
    s3Bucket
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrganizationsQueryVariables,
  APITypes.GetOrganizationsQuery
>;
export const GetPartnerEmails = /* GraphQL */ `query GetPartnerEmails($collaborationRequest: PartnerEmailInput!) {
  GetPartnerEmails(collaborationRequest: $collaborationRequest) {
    data {
      admins
      email
      name
      orgType
      __typename
    }
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPartnerEmailsQueryVariables,
  APITypes.GetPartnerEmailsQuery
>;
export const GetPreSignedUrl = /* GraphQL */ `query GetPreSignedUrl($input: PreSignedUrl) {
  GetPreSignedUrl(input: $input) {
    deleteUrl
    error
    putUrl
    statusCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPreSignedUrlQueryVariables,
  APITypes.GetPreSignedUrlQuery
>;
export const GetQueryRecord = /* GraphQL */ `query GetQueryRecord($engagementId: String!, $queryId: String!) {
  GetQueryRecord(engagementId: $engagementId, queryId: $queryId) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryRecordQueryVariables,
  APITypes.GetQueryRecordQuery
>;
export const GetQueryRecords = /* GraphQL */ `query GetQueryRecords(
  $engagementId: String!
  $filterAggregateWithoutQueryProjection: Boolean
) {
  GetQueryRecords(
    engagementId: $engagementId
    filterAggregateWithoutQueryProjection: $filterAggregateWithoutQueryProjection
  ) {
    CSVKey
    approvalStatus
    approvedBy
    athenaExecutionId
    createdAt
    createdBy
    description
    engagement
    executionDuration
    executionEndTime
    executionStartTime
    executionStatus
    lastModifiedAt
    lastModifiedBy
    metadata
    metadataKey
    name
    orgType
    query
    queryId
    rejectReason
    syntheticResult
    type
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryRecordsQueryVariables,
  APITypes.GetQueryRecordsQuery
>;
export const GetRoles = /* GraphQL */ `query GetRoles {
  GetRoles {
    entitlements
    role
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRolesQueryVariables, APITypes.GetRolesQuery>;
export const GetSecretesPhrase = /* GraphQL */ `query GetSecretesPhrase {
  GetSecretesPhrase
}
` as GeneratedQuery<
  APITypes.GetSecretesPhraseQueryVariables,
  APITypes.GetSecretesPhraseQuery
>;
export const GetSyntheticResult = /* GraphQL */ `query GetSyntheticResult($resultRequest: AggregateResultRequest) {
  GetSyntheticResult(resultRequest: $resultRequest) {
    headers
    rows
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSyntheticResultQueryVariables,
  APITypes.GetSyntheticResultQuery
>;
export const ValidateQueryRecord = /* GraphQL */ `query ValidateQueryRecord($queryRecord: QueryRecordRequest!) {
  ValidateQueryRecord(queryRecord: $queryRecord) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidateQueryRecordQueryVariables,
  APITypes.ValidateQueryRecordQuery
>;
